(function () {
  const SESSION_KEY = "appwiz_search_utm_appended";

  function hasUTMParams(url) {
    return (
      url.searchParams.has("utm_source") ||
      url.searchParams.has("utm_medium") ||
      url.searchParams.has("utm_campaign") ||
      url.searchParams.has("utm_term") ||
      url.searchParams.has("utm_content")
    );
  }

  function getSearchEngineUTM() {
    if (!document.referrer) return null;

    let referrerUrl;

    try {
      referrerUrl = new URL(document.referrer);
    } catch (e) {
      return null;
    }

    const host = referrerUrl.hostname.toLowerCase();

    if (host.includes("google.")) {
      return {
        source: "google",
        medium: "organic",
        campaign: "organic_search"
      };
    }

    if (host.includes("bing.")) {
      return {
        source: "bing",
        medium: "organic",
        campaign: "organic_search"
      };
    }

    if (host.includes("yahoo.")) {
      return {
        source: "yahoo",
        medium: "organic",
        campaign: "organic_search"
      };
    }

    if (host.includes("duckduckgo.")) {
      return {
        source: "duckduckgo",
        medium: "organic",
        campaign: "organic_search"
      };
    }

    if (host.includes("ecosia.")) {
      return {
        source: "ecosia",
        medium: "organic",
        campaign: "organic_search"
      };
    }

    if (host.includes("baidu.")) {
      return {
        source: "baidu",
        medium: "organic",
        campaign: "organic_search"
      };
    }

    if (host.includes("yandex.")) {
      return {
        source: "yandex",
        medium: "organic",
        campaign: "organic_search"
      };
    }

    return null;
  }

  function appendUTM() {
    const currentUrl = new URL(window.location.href);

    // Do not append if UTM already exists
    if (hasUTMParams(currentUrl)) {
      sessionStorage.setItem(SESSION_KEY, "1");
      return;
    }

    // Do not append again during the same session
    if (sessionStorage.getItem(SESSION_KEY) === "1") {
      return;
    }

    const utm = getSearchEngineUTM();

    // Only append for search engines
    if (!utm) {
      sessionStorage.setItem(SESSION_KEY, "1");
      return;
    }

    currentUrl.searchParams.set("utm_source", utm.source);
    currentUrl.searchParams.set("utm_medium", utm.medium);
    currentUrl.searchParams.set("utm_campaign", utm.campaign);
    currentUrl.searchParams.set("utm_content", "appwizards_seo");

    window.history.replaceState({}, "", currentUrl.toString());

    sessionStorage.setItem(SESSION_KEY, "1");
  }

  appendUTM();
})();